import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/withStyles'
import * as commonStyles from '../../../common/_common.scss'
import AdviserProfileWorkExperience from '../../../common/AdviserProfiles/AdviserProfileWorkExperience'
import EditButton from '../../../common/forms/EditButton'
import DeleteButton from '../../../common/forms/DeleteButton'
import AdviserWorkExperienceEditor from './AdviserWorkExperienceEditor'
import * as styles from './_AdviserProfileWorkExperienceEditor.scss'
import { Modal } from 'react-bootstrap'
import PrimaryActionButton from '../../../common/Buttons/PrimaryActionButton'
import SecondaryActionButton from '../../../common/Buttons/SecondaryActionButton'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { actions } from './adviserProfileWorkExperienceEditorActions'

class adviserProfileWorkExperienceEditor extends React.Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    validationstate: PropTypes.object.isRequired,
    formIsValid: PropTypes.bool.isRequired,
    editingProfile: PropTypes.bool.isRequired,

    setAddNewWorkExperience: PropTypes.func.isRequired,
    setStartEditingWorkExperience: PropTypes.func.isRequired,
    setStopEditingWorkExperience: PropTypes.func.isRequired,
    setCancelEditingWorkExperience: PropTypes.func.isRequired,
    setWorkExperience: PropTypes.func.isRequired,
    setWorkExperiencePositionStartMonth: PropTypes.func.isRequired,
    setWorkExperiencePositionStartYear: PropTypes.func.isRequired,
    setWorkExperiencePositionEndMonth: PropTypes.func.isRequired,
    setWorkExperiencePositionEndYear: PropTypes.func.isRequired,
    setWorkExperiencePositionEndDateCurrent: PropTypes.func.isRequired,
    setDeleteWorkExperienceModal: PropTypes.func.isRequired,
    deleteWorkExperience: PropTypes.func.isRequired,
    setCancelDeletingWorkExperience: PropTypes.func.isRequired,

    loadingWorkExperience: PropTypes.bool.isRequired,
    editingWorkExperience: PropTypes.bool.isRequired,
    editingWorkExperienceIndex: PropTypes.number.isRequired,
    deletingWorkExperienceModal: PropTypes.bool.isRequired,
    deletingWorkExperienceIndex: PropTypes.number.isRequired,
    positionStartMonth: PropTypes.number,
    positionStartYear: PropTypes.number,
    positionEndMonth: PropTypes.number,
    positionEndYear: PropTypes.number
  }

  renderPreview () {
    const profile = this.props.profile
    const children = (profile.workExperiences || []).map((experience, index) => {
      return (
        <span key={index}>
          <EditButton
            editing={this.props.editingWorkExperience}
            startEditing={() => {
              this.props.setStartEditingWorkExperience(index)
            }}
          />
          |
          <DeleteButton
            startDeleting={() => {
              this.props.setDeleteWorkExperienceModal(index)
            }}
          />
        </span>
      )
    })

    return (
      <div className={styles['form-bottom-margin'] + ' modal-container'}>
        <AdviserProfileWorkExperience
          experiences={profile.workExperiences || []}
          className={styles['no-bottom-padding']}
        >
          {this.props.editingProfile ? children : null}
        </AdviserProfileWorkExperience>
        {this.props.editingProfile && (
          <a
            className={styles['add-work-button']}
            target='blank'
            onClick={() => {
              this.props.setAddNewWorkExperience()
            }}
          >
            Add work experience to your profile
          </a>
        )}
        <Modal
          show={this.props.deletingWorkExperienceModal}
          aria-labelledby='contained-modal-title'
        >
          <Modal.Header style={{ borderBottom: 'none', paddingLeft: '40px', paddingRight: '40px', paddingTop: '40px' }}>
            <h2>Deleting experience</h2>
          </Modal.Header>
          <Modal.Body style={{ paddingLeft: '40px', paddingRight: '40px' }}>
            <p>
              Are you sure you wish to delete "{this.props.deletingWorkExperienceIndex !== -1 ? (this.props.profile.workExperiences[this.props.deletingWorkExperienceIndex].position) : ('')}" experience?
            </p>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: 'none', paddingLeft: '40px', paddingRight: '40px', paddingBottom: '40px' }}>
            <PrimaryActionButton
              className={commonStyles['delete-confirmation-modal-button']}
              buttonText='Delete'
              onClick={() => {
                this.props.deleteWorkExperience()
              }}
            />
            <SecondaryActionButton
              buttonText='Cancel'
              onClick={() => {
                this.props.setCancelDeletingWorkExperience()
              }}
            />
          </Modal.Footer>
        </Modal>
      </div>
    )
  }

  renderEditor () {
    return (
      <AdviserProfileWorkExperience
        experiences={this.props.profile.workExperiences || []}
        editor
        editingIndex={this.props.editingWorkExperienceIndex}
        className={styles['no-bottom-padding']}
      >
        {(this.props.profile.workExperiences || []).map((experience, index) => {
          if (this.props.editingWorkExperienceIndex === index) {
            return (
              <AdviserWorkExperienceEditor
                key={index}
                formIsValid={this.props.formIsValid}
                experience={experience}
                editingWorkExperience={this.props.editingWorkExperience}
                validationstate={this.props.validationstate}
                stopEditingWorkExperience={() => {
                  this.props.setStopEditingWorkExperience()
                }}
                cancelEditingWorkExperience={() => {
                  this.props.setCancelEditingWorkExperience()
                }}
                positionHandleChange={(validationResult, value) => {
                  this.props.setWorkExperience(validationResult, {
                    position: value,
                    company: experience.company,
                    isCurrentJob: experience.isCurrentJob,
                    positionEndDate: experience.positionEndDate,
                    positionStartDate: experience.positionStartDate
                  })
                }}
                companyHandleChange={(validationResult, value) => {
                  this.props.setWorkExperience(validationResult, {
                    position: experience.position,
                    company: value,
                    isCurrentJob: experience.isCurrentJob,
                    positionEndDate: experience.positionEndDate,
                    positionStartDate: experience.positionStartDate
                  })
                }}
                dateHandleChange={() => {
                  let validationResult = {
                    position: this.props.validationstate.position,
                    company: this.props.validationstate.company
                  }
                  this.props.setWorkExperience(validationResult, {
                    position: experience.position,
                    company: experience.company,
                    isCurrentJob: experience.isCurrentJob,
                    positionStartDate: experience.positionStartDate,
                    positionEndDate: experience.positionEndDate
                  })
                }}
                positionStartMonth={this.props.positionStartMonth}
                positionStartYear={parseInt(this.props.positionStartYear)}
                positionEndMonth={this.props.positionEndMonth}
                positionEndYear={parseInt(this.props.positionEndYear)}
                handlePositionStartMonth={(validationResult, value) => {
                  this.props.setWorkExperiencePositionStartMonth(
                    validationResult,
                    value
                  )
                }}
                handlePositionStartYear={(validationResult, value) => {
                  this.props.setWorkExperiencePositionStartYear(
                    validationResult,
                    value
                  )
                }}
                handlePositionEndMonth={(validationResult, value) => {
                  this.props.setWorkExperiencePositionEndMonth(
                    validationResult,
                    value
                  )
                }}
                handlePositionEndYear={(validationResult, value) => {
                  this.props.setWorkExperiencePositionEndYear(
                    validationResult,
                    value
                  )
                }}
                handleCurrentEndYear={() => {
                  this.props.setWorkExperiencePositionEndDateCurrent()
                }}
              />
            )
          }
        })}
      </AdviserProfileWorkExperience>
    )
  }

  render () {
    if (this.props.editingWorkExperience && this.props.editingProfile) {
      return this.renderEditor()
    }

    return this.renderPreview()
  }
}

const mapStateToProps = ({ adviserProfileEditorContainer }) => {
  return {
    loadingWorkExperience:
      adviserProfileEditorContainer.experiences.loadingWorkExperience,
    editingWorkExperience:
      adviserProfileEditorContainer.experiences.editingWorkExperience,
    editingWorkExperienceIndex:
      adviserProfileEditorContainer.experiences.editingWorkExperienceIndex,
    deletingWorkExperienceModal:
      adviserProfileEditorContainer.experiences.deletingWorkExperienceModal,
    deletingWorkExperienceIndex:
      adviserProfileEditorContainer.experiences.deletingWorkExperienceIndex,
    positionStartMonth:
      adviserProfileEditorContainer.experiences.positionStartMonth,
    positionEndMonth:
      adviserProfileEditorContainer.experiences.positionEndMonth,
    positionStartYear:
      adviserProfileEditorContainer.experiences.positionStartYear,
    positionEndYear: adviserProfileEditorContainer.experiences.positionEndYear,
    formIsValid:
      adviserProfileEditorContainer.experiences.isInvalid.formIsValid,
    validationstate: adviserProfileEditorContainer.experiences.isInvalid,
    allEducation: adviserProfileEditorContainer.experiences.allEducation
  }
}

const mapDispatchToProps = dispatch => {
  const { add, edit, set, deletes } = actions
  return bindActionCreators(
    {
      setAddNewWorkExperience: add.experience,
      setStartEditingWorkExperience: edit.start,
      setStopEditingWorkExperience: edit.stop,
      setCancelEditingWorkExperience: edit.cancel,
      setWorkExperience: set.experience,
      setWorkExperiencePositionStartMonth: set.startMonth,
      setWorkExperiencePositionStartYear: set.startYear,
      setWorkExperiencePositionEndMonth: set.endMonth,
      setWorkExperiencePositionEndYear: set.endYear,
      setWorkExperiencePositionEndDateCurrent: set.endDateCurrent,
      setDeleteWorkExperienceModal: deletes.modal,
      deleteWorkExperience: deletes.experience,
      setCancelDeletingWorkExperience: deletes.cancel
    },
    dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(
   (adviserProfileWorkExperienceEditor)
)
